module.exports = __webpack_public_path__ + "static/overlay-imported-content-dont-e0835c0186577836b5f0191df789b0d2.png";